<template>
    <!-- Mobile overlay when sidebar is visible -->
    <div 
        v-if="isMounted"
        :class="[
            'fixed inset-0 bg-gray-400 dark:bg-zinc-950 sm:hidden z-10 transition-opacity duration-300 ease-in-out',
            visible ? 'opacity-80' : 'opacity-0 pointer-events-none'
        ]"
        @click="$emit('close')"
    />
    
    <Teleport v-if="isMounted" to="#internal-right-sidebar">
        <div :class="[
            'transition-width duration-500 ease-in-out h-full relative z-20',
            allowOverflow ? '' : 'overflow-x-hidden',
            visible ? 'w-72 opacity-1' : 'w-0 opacity-0'
        ]">
            <div class="w-72">
                <div class="pr-6">
                    <slot></slot>
                </div>
            </div>
        </div>
    </Teleport>
</template>


<script setup>
import { ref, onMounted } from 'vue'

const props = defineProps({
    visible: {
        type: Boolean,
        default: false
    },
    allowOverflow: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['close'])


const isMounted = ref(false)

onMounted(() => {
  isMounted.value = true
})

</script>

<style scoped>

</style>